import { ArrayHelpers, FieldArray, FormikProps } from 'formik';
import { fields } from '@synergy/utils';

import { CustomerDetailOverviewFormValues } from '../models/customer-detail-overview-form-values';
import { NotificationSettingFormValues } from '../../../../models/notification-form-values';
import { NotificationsTable } from '../../../../components/notifications/notifications-table';

type ArrayHelper = ArrayHelpers & {
    form: FormikProps<CustomerDetailOverviewFormValues>;
    name: string;
};

const fieldNames = fields<CustomerDetailOverviewFormValues>();

export const CustomerDetailOverviewNotifications = () => {
    const handleEdit = (helper: ArrayHelper) => (values: NotificationSettingFormValues) => {
        const formAddresses = helper.form.values.notificationSettings;
        const index = formAddresses.findIndex(a => a.id === values?.id);
        if (index >= 0) {
            helper.replace(index, values);
        }
    };

    const handleDelete = (helper: ArrayHelper) => (values: NotificationSettingFormValues) => {
        const formAddresses = helper.form.values.notificationSettings;
        const index = formAddresses.findIndex(a => a.id === values?.id);
        if (index >= 0) {
            helper.remove(index);
        }
    };

    return (
        <FieldArray name={fieldNames.notificationSettings}>
            {(helper: ArrayHelper) => (
                <NotificationsTable
                    notifications={helper.form.values.notificationSettings}
                    onCreate={values => helper.push(values)}
                    onDelete={handleDelete(helper)}
                    onEdit={handleEdit(helper)}
                />
            )}
        </FieldArray>
    );
};
